/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function CreateUpdateApplicationError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'CreateUpdateApplicationError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  CreateUpdateApplicationError.prototype = Object.create(Error.prototype);
  CreateUpdateApplicationError.prototype.constructor = CreateUpdateApplicationError;
  
export { CreateUpdateApplicationError }

@inject(HttpClient, apiUrl)
export class CreateUpdateApplicationClient {

    constructor(public client: fetchClient, public url: string) { }
	
	createUpdateApplication_update(	app? :ClaimApplicationDtoInput) : Promise<CreateUpdateApplicationUpdateResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `mutation update($app: ClaimApplicationDtoInput) {
  addUpdateClaimApplication(claimApplication: $app) {
    result {
      id
      ownerId
      reporter {
        contact {
          id
        }
      }
      claimant {
        contact {
          id
        }
      }
    }
    accessToken
    isLocked
  }
}
`,
                variables : {
					app : app ,
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new CreateUpdateApplicationError("http error running 'createUpdateApplication_update', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new CreateUpdateApplicationError("graphql error(s) running 'createUpdateApplication_update', see errors collection fro more details", response, json)
                    }

                    const result: any = CreateUpdateApplicationUpdateResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class AddressDtoInput {
		address1? :string;
		address2? :string;
		address3? :string;
		country? :CountryCodeType;
		dateCreated? :Date;
		postcode? :string;
		town? :string;

    static fromJS(json:any):AddressDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new AddressDtoInput();

	result.address1 = json["address1"];
	result.address2 = json["address2"];
	result.address3 = json["address3"];
result.country= CountryCodeType[<string>json["country"]];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
	result.postcode = json["postcode"];
	result.town = json["town"];

        return result;
    }
}

export class ContactDtoInput {
		address? :AddressDtoInput;
		companyName? :string;
		contactType? :string;
		correspondenceMethod? :string;
		dateCreated? :Date;
		email? :string;
		firstname? :string;
		id? :string;
		isLeadClaimant? :boolean;
		relationshipToLeadClaimant? :string;
		relationshipToLeadClaimantFamilyMember? :string;
		surname? :string;
		telephone? :string;
		telephoneCountryCode? :CountryCodeType;
		title? :string;

    static fromJS(json:any):ContactDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDtoInput();

result.address= AddressDtoInput.fromJS(json["address"]);
	result.companyName = json["companyName"];
	result.contactType = json["contactType"];
	result.correspondenceMethod = json["correspondenceMethod"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
	result.email = json["email"];
	result.firstname = json["firstname"];
	result.id = json["id"];
	result.isLeadClaimant = json["isLeadClaimant"];
	result.relationshipToLeadClaimant = json["relationshipToLeadClaimant"];
	result.relationshipToLeadClaimantFamilyMember = json["relationshipToLeadClaimantFamilyMember"];
	result.surname = json["surname"];
	result.telephone = json["telephone"];
result.telephoneCountryCode= CountryCodeType[<string>json["telephoneCountryCode"]];
	result.title = json["title"];

        return result;
    }
}

export class ClaimantDtoInput {
		additionalClaimants? :Array<ContactDtoInput>;
		anyAdditionalClaimants? :boolean;
		appointRepresentative? :boolean;
		contact? :ContactDtoInput;
		dateCreated? :Date;
		representative? :ContactDtoInput;

    static fromJS(json:any):ClaimantDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimantDtoInput();

if(json["additionalClaimants"]){ 
		result.additionalClaimants = json["additionalClaimants"].map(v=>ContactDtoInput.fromJS(v) );	
	}
	result.anyAdditionalClaimants = json["anyAdditionalClaimants"];
	result.appointRepresentative = json["appointRepresentative"];
result.contact= ContactDtoInput.fromJS(json["contact"]);
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
result.representative= ContactDtoInput.fromJS(json["representative"]);

        return result;
    }
}

export class DeclarationDtoInput {
		additionalInfo? :string;
		dateCreated? :Date;
		declarationConfirmation? :boolean;
		statementOfTruthConfirmation? :boolean;

    static fromJS(json:any):DeclarationDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new DeclarationDtoInput();

	result.additionalInfo = json["additionalInfo"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
	result.declarationConfirmation = json["declarationConfirmation"];
	result.statementOfTruthConfirmation = json["statementOfTruthConfirmation"];

        return result;
    }
}

export class DocumentDtoInput {
		dateCreated? :Date;
		fileId :string;
		fileName? :string;
		fileSize :number;
		fileType? :string;
		id? :string;

    static fromJS(json:any):DocumentDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new DocumentDtoInput();

result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
	result.fileId = json["fileId"];
	result.fileName = json["fileName"];
	result.fileSize = json["fileSize"];
	result.fileType = json["fileType"];
	result.id = json["id"];

        return result;
    }
}

export class EvidenceDtoInput {
		approvalAdminNotes? :string;
		approvalDecisionBy? :string;
		approvalDecisionById? :string;
		approvalDecisionDate? :string;
		approved? :boolean;
		contactId? :string;
		dateCreated? :Date;
		description? :string;
		documents? :Array<DocumentDtoInput>;
		documentType? :string;
		evidenceType? :string;
		id? :string;
		requiresApproval? :boolean;

    static fromJS(json:any):EvidenceDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new EvidenceDtoInput();

	result.approvalAdminNotes = json["approvalAdminNotes"];
	result.approvalDecisionBy = json["approvalDecisionBy"];
	result.approvalDecisionById = json["approvalDecisionById"];
	result.approvalDecisionDate = json["approvalDecisionDate"];
	result.approved = json["approved"];
	result.contactId = json["contactId"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
	result.description = json["description"];
if(json["documents"]){ 
		result.documents = json["documents"].map(v=>DocumentDtoInput.fromJS(v) );	
	}
	result.documentType = json["documentType"];
	result.evidenceType = json["evidenceType"];
	result.id = json["id"];
	result.requiresApproval = json["requiresApproval"];

        return result;
    }
}

export class IssueDtoInput {
		area? :string;
		builderNotified? :boolean;
		builderNotifiedDate? :Date;
		builderNotifiedEvidence? :boolean;
		dateCreated? :Date;
		dateEvident? :Date;
		details? :string;
		evidence? :Array<EvidenceDtoInput>;
		fireSafetyRisk? :boolean;
		fireSafetyRiskList? :Array<string>;
		id? :string;
		reportCarriedOut? :boolean;
		reportDetails? :string;
		waterIngress? :boolean;
		waterIngressDetails? :string;

    static fromJS(json:any):IssueDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new IssueDtoInput();

	result.area = json["area"];
	result.builderNotified = json["builderNotified"];
result.builderNotifiedDate = json["builderNotifiedDate"] ? new Date(json["builderNotifiedDate"]) : null;
	result.builderNotifiedEvidence = json["builderNotifiedEvidence"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
result.dateEvident = json["dateEvident"] ? new Date(json["dateEvident"]) : null;
	result.details = json["details"];
if(json["evidence"]){ 
		result.evidence = json["evidence"].map(v=>EvidenceDtoInput.fromJS(v) );	
	}
	result.fireSafetyRisk = json["fireSafetyRisk"];
	result.fireSafetyRiskList = json["fireSafetyRiskList"];
	result.id = json["id"];
	result.reportCarriedOut = json["reportCarriedOut"];
	result.reportDetails = json["reportDetails"];
	result.waterIngress = json["waterIngress"];
	result.waterIngressDetails = json["waterIngressDetails"];

        return result;
    }
}

export class PropertyDtoInput {
		address? :AddressDtoInput;
		agent? :ContactDtoInput;
		agreementDate? :Date;
		anyContractualRemedy? :boolean;
		buildingWork? :boolean;
		buildingWorkDetails? :string;
		commercialPropertyType? :string;
		contractorDetails? :string;
		contractualRemedyDetails? :string;
		dateCreated? :Date;
		freeholder? :ContactDtoInput;
		hasAgent? :boolean;
		newBuildOrConversion? :string;
		noSurveyReason? :string;
		otherInsurance? :boolean;
		otherInsuranceDetails? :string;
		overseeingBuilder? :ContactDtoInput;
		overseeingBuilderEmployed? :boolean;
		overseeingBuilderStartDate? :Date;
		ownershipType? :string;
		policyKnown? :boolean;
		policyNumber? :string;
		previousClaim? :boolean;
		previousClaimDetails? :string;
		propertyType? :string;
		purchased? :boolean;
		purchaseDate? :Date;
		purchasePrice? :string;
		reasonReduced? :string;
		reduced? :boolean;
		reductionAmount? :string;
		residentialPropertyType? :string;
		retention? :boolean;
		retentionAmount? :string;
		retentionReason? :string;
		selfBuild? :boolean;
		selfBuildStartDate? :Date;
		surveyCompleted? :boolean;
		usage? :string;

    static fromJS(json:any):PropertyDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new PropertyDtoInput();

result.address= AddressDtoInput.fromJS(json["address"]);
result.agent= ContactDtoInput.fromJS(json["agent"]);
result.agreementDate = json["agreementDate"] ? new Date(json["agreementDate"]) : null;
	result.anyContractualRemedy = json["anyContractualRemedy"];
	result.buildingWork = json["buildingWork"];
	result.buildingWorkDetails = json["buildingWorkDetails"];
	result.commercialPropertyType = json["commercialPropertyType"];
	result.contractorDetails = json["contractorDetails"];
	result.contractualRemedyDetails = json["contractualRemedyDetails"];
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
result.freeholder= ContactDtoInput.fromJS(json["freeholder"]);
	result.hasAgent = json["hasAgent"];
	result.newBuildOrConversion = json["newBuildOrConversion"];
	result.noSurveyReason = json["noSurveyReason"];
	result.otherInsurance = json["otherInsurance"];
	result.otherInsuranceDetails = json["otherInsuranceDetails"];
result.overseeingBuilder= ContactDtoInput.fromJS(json["overseeingBuilder"]);
	result.overseeingBuilderEmployed = json["overseeingBuilderEmployed"];
result.overseeingBuilderStartDate = json["overseeingBuilderStartDate"] ? new Date(json["overseeingBuilderStartDate"]) : null;
	result.ownershipType = json["ownershipType"];
	result.policyKnown = json["policyKnown"];
	result.policyNumber = json["policyNumber"];
	result.previousClaim = json["previousClaim"];
	result.previousClaimDetails = json["previousClaimDetails"];
	result.propertyType = json["propertyType"];
	result.purchased = json["purchased"];
result.purchaseDate = json["purchaseDate"] ? new Date(json["purchaseDate"]) : null;
	result.purchasePrice = json["purchasePrice"];
	result.reasonReduced = json["reasonReduced"];
	result.reduced = json["reduced"];
	result.reductionAmount = json["reductionAmount"];
	result.residentialPropertyType = json["residentialPropertyType"];
	result.retention = json["retention"];
	result.retentionAmount = json["retentionAmount"];
	result.retentionReason = json["retentionReason"];
	result.selfBuild = json["selfBuild"];
result.selfBuildStartDate = json["selfBuildStartDate"] ? new Date(json["selfBuildStartDate"]) : null;
	result.surveyCompleted = json["surveyCompleted"];
	result.usage = json["usage"];

        return result;
    }
}

export class ReporterDtoInput {
		contact? :ContactDtoInput;
		dateCreated? :Date;
		isRepresenting? :boolean;
		securityAnswer? :string;
		securityQuestion? :string;

    static fromJS(json:any):ReporterDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ReporterDtoInput();

result.contact= ContactDtoInput.fromJS(json["contact"]);
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
	result.isRepresenting = json["isRepresenting"];
	result.securityAnswer = json["securityAnswer"];
	result.securityQuestion = json["securityQuestion"];

        return result;
    }
}

export class ClaimApplicationDtoInput {
		claimant? :ClaimantDtoInput;
		dateCreated? :Date;
		declaration? :DeclarationDtoInput;
		evidence? :Array<EvidenceDtoInput>;
		id? :string;
		isDuplicate? :boolean;
		issues? :Array<IssueDtoInput>;
		outputDocument? :DocumentDtoInput;
		ownerId? :string;
		property? :PropertyDtoInput;
		reporter? :ReporterDtoInput;
		screeningInformationViewed :PolicyType;
		status? :ClaimStatus;

    static fromJS(json:any):ClaimApplicationDtoInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationDtoInput();

result.claimant= ClaimantDtoInput.fromJS(json["claimant"]);
result.dateCreated = json["dateCreated"] ? new Date(json["dateCreated"]) : null;
result.declaration= DeclarationDtoInput.fromJS(json["declaration"]);
if(json["evidence"]){ 
		result.evidence = json["evidence"].map(v=>EvidenceDtoInput.fromJS(v) );	
	}
	result.id = json["id"];
	result.isDuplicate = json["isDuplicate"];
if(json["issues"]){ 
		result.issues = json["issues"].map(v=>IssueDtoInput.fromJS(v) );	
	}
result.outputDocument= DocumentDtoInput.fromJS(json["outputDocument"]);
	result.ownerId = json["ownerId"];
result.property= PropertyDtoInput.fromJS(json["property"]);
result.reporter= ReporterDtoInput.fromJS(json["reporter"]);
result.screeningInformationViewed= PolicyType[<string>json["screeningInformationViewed"]];
result.status= ClaimStatus[<string>json["status"]];

        return result;
    }
}

export class CreateUpdateApplicationUpdateResult {
		addUpdateClaimApplication? :ClaimApplicationResultResult;

    static fromJS(json:any):CreateUpdateApplicationUpdateResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new CreateUpdateApplicationUpdateResult();

result.addUpdateClaimApplication= ClaimApplicationResultResult.fromJS(json["addUpdateClaimApplication"]);

        return result;
    }
}

export class ClaimApplicationResultResult {
		result? :ClaimApplicationDtoResult;
		accessToken? :string;
		isLocked :boolean;

    static fromJS(json:any):ClaimApplicationResultResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationResultResult();

result.result= ClaimApplicationDtoResult.fromJS(json["result"]);
	result.accessToken = json["accessToken"];
	result.isLocked = json["isLocked"];

        return result;
    }
}

export class ClaimApplicationDtoResult {
		id? :string;
		ownerId? :string;
		reporter? :ReporterDtoResult;
		claimant? :ClaimantDtoResult;

    static fromJS(json:any):ClaimApplicationDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationDtoResult();

	result.id = json["id"];
	result.ownerId = json["ownerId"];
result.reporter= ReporterDtoResult.fromJS(json["reporter"]);
result.claimant= ClaimantDtoResult.fromJS(json["claimant"]);

        return result;
    }
}

export class ReporterDtoResult {
		contact? :ContactDtoResult;

    static fromJS(json:any):ReporterDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ReporterDtoResult();

result.contact= ContactDtoResult.fromJS(json["contact"]);

        return result;
    }
}

export class ContactDtoResult {
		id? :string;

    static fromJS(json:any):ContactDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDtoResult();

	result.id = json["id"];

        return result;
    }
}

export class ClaimantDtoResult {
		contact? :ContactDtoResult;

    static fromJS(json:any):ClaimantDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimantDtoResult();

result.contact= ContactDtoResult.fromJS(json["contact"]);

        return result;
    }
}


	export enum CountryCodeType
	{
		NONE = "NONE",
		AFGHANISTAN = "AFGHANISTAN",
		ALBANIA = "ALBANIA",
		ALGERIA = "ALGERIA",
		AMERICANSAMOA = "AMERICANSAMOA",
		ANDORRA = "ANDORRA",
		ANGOLA = "ANGOLA",
		ANGUILLA = "ANGUILLA",
		ANTARCTICA = "ANTARCTICA",
		ARGENTINA = "ARGENTINA",
		ARMENIA = "ARMENIA",
		ARUBA = "ARUBA",
		AUSTRALIA = "AUSTRALIA",
		AUSTRIA = "AUSTRIA",
		AZERBAIJAN = "AZERBAIJAN",
		BAHAMAS = "BAHAMAS",
		BAHRAIN = "BAHRAIN",
		BANGLADESH = "BANGLADESH",
		BARBADOS = "BARBADOS",
		BELARUS = "BELARUS",
		BELGIUM = "BELGIUM",
		BELIZE = "BELIZE",
		BENIN = "BENIN",
		BERMUDA = "BERMUDA",
		BHUTAN = "BHUTAN",
		BOLIVIA = "BOLIVIA",
		BOSNIAANDHERZEGOVINA = "BOSNIAANDHERZEGOVINA",
		BOTSWANA = "BOTSWANA",
		BRAZIL = "BRAZIL",
		BRITISHVIRGINISLANDS = "BRITISHVIRGINISLANDS",
		BRUNEI = "BRUNEI",
		BULGARIA = "BULGARIA",
		BURKINAFASO = "BURKINAFASO",
		BURUNDI = "BURUNDI",
		CAMBODIA = "CAMBODIA",
		CAMEROON = "CAMEROON",
		CANADA = "CANADA",
		CAPEVERDE = "CAPEVERDE",
		CAYMANISLANDS = "CAYMANISLANDS",
		CENTRALAFRICANREPUBLIC = "CENTRALAFRICANREPUBLIC",
		CHILE = "CHILE",
		CHINA = "CHINA",
		COLOMBIA = "COLOMBIA",
		COMOROS = "COMOROS",
		COOKISLANDS = "COOKISLANDS",
		COSTARICA = "COSTARICA",
		CROATIA = "CROATIA",
		CUBA = "CUBA",
		CURACAO = "CURACAO",
		CYPRUS = "CYPRUS",
		CZECHREPUBLIC = "CZECHREPUBLIC",
		DEMOCRATICREPUBLICOFCONGO = "DEMOCRATICREPUBLICOFCONGO",
		DENMARK = "DENMARK",
		DJIBOUTI = "DJIBOUTI",
		DOMINICA = "DOMINICA",
		DOMINICANREPUBLIC = "DOMINICANREPUBLIC",
		EASTTIMOR = "EASTTIMOR",
		ECUADOR = "ECUADOR",
		EGYPT = "EGYPT",
		ELSALVADOR = "ELSALVADOR",
		EQUATORIALGUINEA = "EQUATORIALGUINEA",
		ERITREA = "ERITREA",
		ESTONIA = "ESTONIA",
		ETHIOPIA = "ETHIOPIA",
		FALKLANDISLANDS = "FALKLANDISLANDS",
		FAROEISLANDS = "FAROEISLANDS",
		FIJI = "FIJI",
		FINLAND = "FINLAND",
		FRANCE = "FRANCE",
		FRENCHPOLYNESIA = "FRENCHPOLYNESIA",
		GABON = "GABON",
		GAMBIA = "GAMBIA",
		GEORGIA = "GEORGIA",
		GERMANY = "GERMANY",
		GHANA = "GHANA",
		GIBRALTAR = "GIBRALTAR",
		GREECE = "GREECE",
		GREENLAND = "GREENLAND",
		GUADELOUPE = "GUADELOUPE",
		GUAM = "GUAM",
		GUATEMALA = "GUATEMALA",
		GUINEA = "GUINEA",
		GUINEABISSAU = "GUINEABISSAU",
		GUYANA = "GUYANA",
		HAITI = "HAITI",
		HONDURAS = "HONDURAS",
		HONGKONG = "HONGKONG",
		HUNGARY = "HUNGARY",
		ICELAND = "ICELAND",
		INDIA = "INDIA",
		INDONESIA = "INDONESIA",
		IRAN = "IRAN",
		IRAQ = "IRAQ",
		IRELAND = "IRELAND",
		ISLEOFMAN = "ISLEOFMAN",
		ISRAEL = "ISRAEL",
		ITALY = "ITALY",
		IVORYCOAST = "IVORYCOAST",
		JAMAICA = "JAMAICA",
		JAPAN = "JAPAN",
		JORDAN = "JORDAN",
		KAZAKHSTAN = "KAZAKHSTAN",
		KENYA = "KENYA",
		KIRIBATI = "KIRIBATI",
		KOSOVO = "KOSOVO",
		KUWAIT = "KUWAIT",
		KYRGYZSTAN = "KYRGYZSTAN",
		LAOS = "LAOS",
		LATVIA = "LATVIA",
		LEBANON = "LEBANON",
		LESOTHO = "LESOTHO",
		LIBERIA = "LIBERIA",
		LIBYA = "LIBYA",
		LIECHTENSTEIN = "LIECHTENSTEIN",
		LITHUANIA = "LITHUANIA",
		LUXEMBOURG = "LUXEMBOURG",
		MACAU = "MACAU",
		MACEDONIA = "MACEDONIA",
		MADAGASCAR = "MADAGASCAR",
		MALAWI = "MALAWI",
		MALAYSIA = "MALAYSIA",
		MALDIVES = "MALDIVES",
		MALI = "MALI",
		MALTA = "MALTA",
		MARSHALLISLANDS = "MARSHALLISLANDS",
		MAURITANIA = "MAURITANIA",
		MAURITIUS = "MAURITIUS",
		MEXICO = "MEXICO",
		MICRONESIA = "MICRONESIA",
		MOLDOVA = "MOLDOVA",
		MONACO = "MONACO",
		MONGOLIA = "MONGOLIA",
		MONTENEGRO = "MONTENEGRO",
		MONTSERRAT = "MONTSERRAT",
		MOROCCO = "MOROCCO",
		MOZAMBIQUE = "MOZAMBIQUE",
		MYANMARBURMA = "MYANMARBURMA",
		NAMIBIA = "NAMIBIA",
		NAURU = "NAURU",
		NEPAL = "NEPAL",
		NETHERLANDS = "NETHERLANDS",
		NEWCALEDONIA = "NEWCALEDONIA",
		NEWZEALAND = "NEWZEALAND",
		NICARAGUA = "NICARAGUA",
		NIGER = "NIGER",
		NIGERIA = "NIGERIA",
		NIUE = "NIUE",
		NORFOLKISLAND = "NORFOLKISLAND",
		NORTHKOREA = "NORTHKOREA",
		NORTHERNMARIANAISLANDS = "NORTHERNMARIANAISLANDS",
		NORWAY = "NORWAY",
		OMAN = "OMAN",
		PAKISTAN = "PAKISTAN",
		PALAU = "PALAU",
		PANAMA = "PANAMA",
		PAPUANEWGUINEA = "PAPUANEWGUINEA",
		PARAGUAY = "PARAGUAY",
		PERU = "PERU",
		PHILIPPINES = "PHILIPPINES",
		PITCAIRNISLANDS = "PITCAIRNISLANDS",
		POLAND = "POLAND",
		PORTUGAL = "PORTUGAL",
		PUERTORICO = "PUERTORICO",
		QATAR = "QATAR",
		REPUBLICOFTHECONGO = "REPUBLICOFTHECONGO",
		REUNION = "REUNION",
		ROMANIA = "ROMANIA",
		RUSSIA = "RUSSIA",
		RWANDA = "RWANDA",
		SAINTBARTHELEMY = "SAINTBARTHELEMY",
		SAINTHELENA = "SAINTHELENA",
		SAINTKITTSANDNEVIS = "SAINTKITTSANDNEVIS",
		SAINTLUCIA = "SAINTLUCIA",
		SAINTMARTIN = "SAINTMARTIN",
		SAINTPIERREANDMIQUELON = "SAINTPIERREANDMIQUELON",
		SAINTVINCENTANDTHEGRENADINES = "SAINTVINCENTANDTHEGRENADINES",
		SAMOA = "SAMOA",
		SANMARINO = "SANMARINO",
		SAOTOMEANDPRINCIPE = "SAOTOMEANDPRINCIPE",
		SAUDIARABIA = "SAUDIARABIA",
		SENEGAL = "SENEGAL",
		SERBIA = "SERBIA",
		SEYCHELLES = "SEYCHELLES",
		SIERRALEONE = "SIERRALEONE",
		SINGAPORE = "SINGAPORE",
		SLOVAKIA = "SLOVAKIA",
		SLOVENIA = "SLOVENIA",
		SOLOMONISLANDS = "SOLOMONISLANDS",
		SOMALIA = "SOMALIA",
		SOUTHAFRICA = "SOUTHAFRICA",
		SOUTHKOREA = "SOUTHKOREA",
		SOUTHSUDAN = "SOUTHSUDAN",
		SPAIN = "SPAIN",
		SRILANKA = "SRILANKA",
		SUDAN = "SUDAN",
		SURINAME = "SURINAME",
		SWAZILAND = "SWAZILAND",
		SWEDEN = "SWEDEN",
		SWITZERLAND = "SWITZERLAND",
		SYRIA = "SYRIA",
		TAIWAN = "TAIWAN",
		TAJIKISTAN = "TAJIKISTAN",
		TANZANIA = "TANZANIA",
		THAILAND = "THAILAND",
		TOGO = "TOGO",
		TOKELAU = "TOKELAU",
		TRINIDADANDTOBAGO = "TRINIDADANDTOBAGO",
		TUNISIA = "TUNISIA",
		TURKEY = "TURKEY",
		TURKMENISTAN = "TURKMENISTAN",
		TUVALU = "TUVALU",
		UGANDA = "UGANDA",
		UKRAINE = "UKRAINE",
		UNITEDARABEMIRATES = "UNITEDARABEMIRATES",
		UNITEDKINGDOM = "UNITEDKINGDOM",
		UNITEDSTATES = "UNITEDSTATES",
		URUGUAY = "URUGUAY",
		UZBEKISTAN = "UZBEKISTAN",
		VANUATU = "VANUATU",
		VATICAN = "VATICAN",
		VENEZUELA = "VENEZUELA",
		VIETNAM = "VIETNAM",
		WESTERNSAHARA = "WESTERNSAHARA",
		YEMEN = "YEMEN",
		ZAMBIA = "ZAMBIA",
		ZIMBABWE = "ZIMBABWE",
	}

	export enum PolicyType
	{
		UNKNOWN = "UNKNOWN",
		NEWHOMES = "NEWHOMES",
		SOCIALHOUSING = "SOCIALHOUSING",
		PRS = "PRS",
		COMMERCIAL = "COMMERCIAL",
		SELFBUILD = "SELFBUILD",
		COMPLETED = "COMPLETED",
		INSOLVENCY = "INSOLVENCY",
		ASUCDIG = "ASUCDIG",
		ASUCBIG = "ASUCBIG",
		ROADSEWERBONDS = "ROADSEWERBONDS",
	}

	export enum ClaimStatus
	{
		INCOMPLETE = "INCOMPLETE",
		SUBMITTED = "SUBMITTED",
		REVIEWED = "REVIEWED",
		ARCHIVED = "ARCHIVED",
	}

